import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory} from "react-router-dom";
import { Card } from '@mui/material';
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import PageTitle from "../UI/PageTitle";
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import FileUploader from "../FileUploader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AddComigsoonOutlet() {
    let history = useHistory();

    const [selectedFile, setSelectedFile] = useState(null);
    const [outlet, setOutlet] = useState({
        name: '',
        status: '',
       
    });

    const handleFileSelectSuccess = (file) => {
        setSelectedFile(file);
      };
    
      const handleFileSelectError = ({ error }) => {
        alert(error);
      };
      
    const [loading, setloading] = useState(false);
    const { name , status } = outlet;
    const onInputChange = e => {
        setOutlet({ ...outlet, [e.target.name]: e.target.value })
        //console.log(airmenu_id,"jeet");
    }

    const onSubmit = async e => {
        setloading(true);
        e.preventDefault();
        
        if (!selectedFile) {
            alert('Please select an image');
            setloading(false);
            return false;
        }
    
      
        const formData = new FormData();
        formData.append("name", name);   
        formData.append("status", status);

        formData.append("image", selectedFile);
       // console.log(formData)
        try{
            const response = await axios.post(endpoints.addLotdCSoon,formData);
            setloading(false);  // Set loader to false on successful API call
            history.goBack();
        
            if (response.data && response.data.status === true) {
               
                toast.success('Coming Outlet Added Successfully!', {
                  position: 'top-right',
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: 'colored',
                });
              } else {
                // Handle other cases if needed
              }
            } catch (error) {
              console.error('Error during editing Outlet:', error);
              setloading(false);
          
              toast.error('Error during editing Outlet. Please try again.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
              });
            }


       
    }
  return (
    <div>
         <PageTitle title="Add Coming Soon Outlet" linkurl="" linkTitle="" />
        
        <Card className="px-3 py-3 mt-4">
                <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
                <div className="row mt-3">
                        <Input label="Name" type="text" name="name" place="Name" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={name} class="col-md-4"
                        />
                          <div className="col col-4 mt-2">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
                        <div className="col-md-4">
                            <label>Image</label>
                            <FileUploader
        onFileSelectSuccess={handleFileSelectSuccess}
        onFileSelectError={handleFileSelectError}
      />

      {selectedFile && (
        <div>
          <p>Preview:</p>
          <img
            src={URL.createObjectURL(selectedFile)}
            alt="Selected Logo"
            height="200px" width="200px" className="mt-3"
           
          />
        </div>
      )}
                        </div>
                    </div>
                   
                  


                    <div className="row">
                        <div className="col col-6">
                            <div className="mt-3">
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                                <ToastContainer />

                            </div></div></div>


                </form>
            </Card>
    </div>
  )
}

export default AddComigsoonOutlet